export default {
    data() {
        return {
            datepicker_default_local: {
                fr: {
                    dow: 1, // Sunday is the first day of the week
                    hourTip: 'Select Hour', // tip of select hour
                    minuteTip: 'Select Minute', // tip of select minute
                    secondTip: 'Select Second', // tip of select second
                    yearSuffix: '', // suffix of head year
                    monthsHead: 'Janvier_Février_Mars_Avril_Mai_Juin_Juillet_Aout_Septembre_Octobre_Novembre_Décembre'.split('_'), // months of head
                    months: 'Jan_Fév_Mar_Avr_Mai_Juin_Juil_Aou_Sep_Oct_Nov_Déc'.split('_'), // months of panel
                    weeks: 'Lu_Ma_Me_Je_Ve_Sa_Di'.split('_'), // weeks,
                    cancelTip: 'cancel',
                    submitTip: 'confirm'
                },
                en: {
                    dow: 1, // Sunday is the first day of the week
                    hourTip: 'Select Hour', // tip of select hour
                    minuteTip: 'Select Minute', // tip of select minute
                    secondTip: 'Select Second', // tip of select second
                    yearSuffix: '', // suffix of head year
                    monthsHead: 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'), // months of head
                    months: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'), // months of panel
                    weeks: 'Mo_Tu_We_Th_Fr_Sa_Su'.split('_'), // weeks,
                    cancelTip: 'cancel',
                    submitTip: 'confirm'
                }
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/mixins/datepickerLocalization.js